import type { RuleExpansionCache } from "./build-days.js";

/**
 * Route changes unmount the current calendar view, so hook-local recurrence
 * caches go cold when toggling Month <-> Week/Day. Keep the rule expansion cache
 * at module scope so adjacent calendar views can reuse the same quantized blocks.
 */
const calendarRuleExpansionCache: RuleExpansionCache = new Map();

export function getCalendarRuleExpansionCache(): RuleExpansionCache {
  return calendarRuleExpansionCache;
}
